export class Effect {
  id: number;
  date: string;
  amount: number;
  amount_no_punteado: number;
  account: string;
  company_id: number;
  state: string;
  concept:string;
  effect_type:string;
  invoice_number:string;
  origin_id:string;
  origin:string;
  deleted:boolean;
  due_date:string;

  constructor(id: number, date:string, amount: number, amount_no_punteado: number, account: string, company_id: number, state: string, concept:string, effect_type:string, invoice_number:string, origin_id:string, origin:string, deleted:boolean, due_date:string) {
      this.id = id;
      this.date = date;
      this.amount = amount;
      this.amount_no_punteado = amount_no_punteado;
      this.account = account;
      this.company_id = company_id;
      this.state = state;
      this.concept = concept;
      this.effect_type = effect_type;
      this.invoice_number = invoice_number;
      this.origin_id = origin_id;
      this.origin = origin;
      this.deleted = deleted;
      this.due_date = due_date;
  }

  clone(): Effect {
      return new Effect(this.id, this.date, this.amount, this.amount_no_punteado, this.account, this.company_id, this.state, this.concept, this.effect_type, this.invoice_number, this.origin_id, this.origin, this.deleted, this.due_date);
  }
}
